export const ERROR_MESSAGE = "Error: Unable to send health check request";
